export const TOP_CATEGORIES_DEPTH_LIMIT = '*';
